import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bag",
  "use": "bag-usage",
  "viewBox": "0 0 14 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 14\" id=\"bag\"><path d=\"M9.92 8.75v-.58H14V14H0V8.17h4.08v.58h1.17v-.58h3.5v.58zm0-5.83H14V7H9.92v-.58H8.75V7h-3.5v-.58H4.08V7H0V2.92h4.08V0h5.84zm-1.17 0V1.17h-3.5v1.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol